module.exports = __webpack_public_path__ + "img/box_img2.e6238abf.png";